import React, { useEffect, useState } from 'react';
import { useCameraViewContext } from '../../context';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import { useVideoUrl } from '../../hooks/useVideoUrl';
import AutoPlayVideo from 'components/AutoPlayVideo';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 3;
  display: flex;
  flex-direction: column;
  position: relative;

  @media (orientation: landscape) {
    background-size: contain;
    background-position: center;
    aspect-ratio: auto;
    height: 100%;
  }
`;

const ChildWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
`;

type Props = {
  children: React.ReactNode;
};

export const VideoPreview = ({ children }: Props) => {
  const { recordedChunks } = useCameraViewContext();
  const videoUrl = useVideoUrl(recordedChunks);

  if (!videoUrl) return null;
  return (
    <Wrapper>
      <AutoPlayVideo src={videoUrl} />
      <ChildWrapper>{children}</ChildWrapper>
    </Wrapper>
  );
};
